import { ctaFields, image } from "../../utils/helperQuery.wp";

export const heroCtaQuery = `
    ... on PageComponentsPageComponentsBlockHeroCtaLayout {
        fieldGroupName
         
        heading
        description
        image {
            ${image}
        }
        imageBackground {
            ${image}
        }
        cta {
            ${ctaFields}
        }
        ctaSecondary {
            ${ctaFields}
        }
    }
`;

export const heroCtaGlobalQuery = `
    globalOptionsDefault {
        globalHerocta {
            global_herocta_cta {
                ${ctaFields}
            }
        }
    }
`;
